<svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
<path d="M12 0C5.373 0 0 5.373 0 12C0 18.627 5.373 24 12 24C18.627 24 24 18.627 24 12C24 5.373 18.627 0 12 0ZM18 13H6C5.448 13 5 12.553 5 12C5 11.447 5.448 11 6 11H18C18.552 11 19 11.447 19 12C19 12.553 18.552 13 18 13Z" fill="#000000"/>
</svg>
